import styled from "styled-components";

export const PlacementOptionWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    .product-item-wrapper {
    display: flex;
    align-items: flex-start;
    grid-gap: 10px;
    img {
    width: 40px;
    height: 28px;
    object-fit: contain;
}
.product-item {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
}
.ag-cell{
  &:not(:first-child){
    border-left:1px solid #ECEFF1;
  }
}
footer{
  display: flex;
  justify-content: end;
  align-items: center;
  margin-top: 12px;
  grid-gap: 16px;
}
.ant-spin-nested-loading {
    position: relative;
    width: 100%;
}

.cards-overlay-wrapper{
  background-color: #fff;
  border: 1px solid #ECEFF1;
  border-radius: 4px;
  padding: 8px;
  min-height: 300px;
  height: auto;
  max-height: calc(100vh - 136px);
  overflow: auto;
  max-width: 331px;
  width: 100%;
  &.loading-accured{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    span.ant-spin-dot.ant-spin-dot-spin {
    margin-top: -20px;
}
 .ant-spin-text {
    left: 0px;
}
  }
}
.content-area-wrapper {
    width: calc(100% - 340px);
.tabs-cards-wrapper {
    background: #E6F4FC;
    padding: 14px 12px;
    border-radius: 4px;
    width: 100%;
    display: flex;
    overflow: auto;
    grid-gap: 12px;
    margin-bottom: 9px;
    &::-webkit-scrollbar {
      display: none;
    }
    .tab-item-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    max-width: 350px;
    min-width: 350px;
    grid-gap: 8px;
    width: 100%;
    background: #F5FBFF;
    padding: 12px;
    border-radius: 4px;
    border:1px solid transparent;
    cursor: pointer;
    &.active{
      background: #fff;
      border-color: #1565D8;

    }
    .tab-item {
        display: flex;
        flex-direction: column;
        grid-row-gap: 2px;
        p {
        margin: 0px;
        font-weight: 400;
        font-size: 10px;
        line-height: 12px;
        letter-spacing: 0%;
        color: #808183;
        &:not(:first-child){
          font-weight: 600;
          color: #535E63;
          
        }
}
    }
}
}
}
`;
